import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";

const TermsConditions = () => {
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (agreed) {
      //get the docId and update the agree: true,
      sessionStorage.setItem("agreed", "true");
      navigate("/UserProfile"); // Navigate to Register1 page
    }
  };

  const handleAgreeChange = () => {
    setAgreed(!agreed);
  };

  return (
    <Container className='image-container-dk mb-5 modal-content'>
      <Row>
        <h3>
          Piermont Flywheel Gallery - Guest Artist Showcase Terms and Conditions
        </h3>
        <h5>Guidance and Support</h5>
        <p>
          Throughout all stages of your show, you will receive guidance and
          support from members of the gallery.
        </p>

        <p>
          
          We're thrilled to have you as part of our artistic family for these
          exciting exhibit. The shows will run for four weeks each, covering
          four long weekends. Please read and accept the following terms and
          conditions for a smooth and successful exhibit.
        </p>

        <h5>About the Showcase</h5>
        <p>
          Each "Guest Artist Showcase" features four talented artists. Each artist will have approximately 13 feet of running wall
          space to display their work, with group participation of all four
          artists on a feature wall.
        </p>

        <h5>Hanging and Labeling:</h5>
        <p>
          Hanging is tentatively scheduled for the Tuesday before the opening of
          your show. Hanging guidelines and label formats will be provided in
          advance.Artists are responsible for hanging their own work and
          creating labels according to provided guidelines. Artists must adhere
          to gallery standards for labels, signage and easel usage.
        </p>

        <h5>Hours and Management:</h5>
        <p>
          The gallery will be co-run by the four guest artists during the
          exhibit. Artists are required to open and close the gallery on their
          scheduled days. For each showcase the gallery must be open for 16 days
          (Thursdays through Sundays), subject to safety and weather conditions.
          Artists will collaborate to determine their gallery hour schedules.
          Opening during additional hours is strongly encouraged but voluntary.
        </p>

        <h5>Sales and Proceeds:</h5>
        <p>
          When using your own means of transacting, you keep 100% of the
          proceeds. You are responsible for collecting appropriate sales taxes.
          When using the gallery's credit card machine, you receive 100% of the
          sale amount minus credit card processing fees by our bank. When
          covering the gallery, artists must handle sales for all artists in the
          gallery, including processing credit cards and maintaining receipts.
          Training will be provided.
        </p>

        <h5>Participation Fee:</h5>
        <p>
          The participation fee is $450, payable via Zelle or by check upon
          confirmation of participation and before hanging days.
        </p>

        <h5>Gallery Maintenance:</h5>
        <p>
          Artists will be provided with a gallery key and are entrusted to
          return it at the end of the show. Artists are responsible for
          maintaining the gallery's positive appearance, including basic
          cleaning tasks and guest interaction.
        </p>

        <h5>Marketing Collaboration:</h5>
        <p>
          PFG has been the premier gallery in Piermont for more than three
          decades. You'll be able to leverage our wide social media exposure and
          promote your work through your own social media channels as well.
          We'll help you develop a marketing plan that will include email and
          digital marketing. Artists should forward marketing emails to their
          followers and provide email addresses for our distribution list.
        </p>

        <h5>Artist Receptions:</h5>
        <p>
          We encourage artists to host opening receptions and individual
          receptions for each artist during the show.
        </p>

      </Row>
      <Row className='d-flex justify-content-between mb-3'>
        <Col lg={"6"}>
          <Form.Group controlId='formBasicCheckbox'>
            <Form.Check
              type='checkbox'
              label='I agree to the terms and conditions'
              checked={agreed}
              onChange={handleAgreeChange}
            />
          </Form.Group>
        </Col>
        <Col lg={"6"}>
          <Button variant='primary' disabled={!agreed} onClick={handleSubmit}>
            Submit
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default TermsConditions;
